<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header" v-if="showDialogHeader">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md4>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Số đề nghị:
                                    {{ createItem.requestNumber }}
                                </p>
                                <p class="font-weight-bold">
                                    Khu nuôi: {{ areaCode }}
                                </p>
                                <p class="font-weight-bold" v-if="createItem.assetsNameId > 0">
                                    Tên tài sản: {{ getAssetsNameName(createItem.assetsNameId) }}
                                </p>
                                <p class="font-weight-bold">
                                    Trạng thái:
                                    <span v-if="exportRequest.status == 6" style="color: green">{{exportStatusName()}}</span>
                                    <span v-else style="color: #d9d900">{{exportStatusName()}}</span>
                                </p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                            <div style="padding: 20px 10px">
                                <!-- <div>
                                    <i-datepicker
                                        label="Ngày xuất kho yêu cầu"
                                        v-model="createItem.exportDate"
                                        :minDate="minDate()"
                                        @change="onChangeExportDate()"
                                    />
                                </div> -->
                                <p class="font-weight-bold">
                                    Ngày xuất kho yêu cầu: {{ createItem.exportDate }}
                                </p>
                                <p class="font-weight-bold">
                                    Vụ nuôi: {{ cropName }}
                                </p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Người đề nghị xuất kho:
                                    {{ createItem.userCreateName }}
                                </p>
                                <p class="font-weight-bold">
                                    Ngày tuổi tôm: {{ createItem.shrimpAge }}
                                </p>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
<!--                        <v-flex md4 style="padding: 10px">-->

<!--                            <v-autocomplete-->
<!--                                :items="lstMaterialTypeAlly"-->
<!--                                label="Chọn nhóm của nhóm vật tư"-->
<!--                                v-model="createItem.materialTypeAllyId"-->
<!--                                item-value="categoryId"-->
<!--                                item-text="categoryName"-->
<!--                                disabled-->
<!--                            />-->


<!--                        </v-flex>-->
                        <v-flex md8 style="padding: 10px">
                            <v-textarea
                                v-if="showUpdate"
                                outlined
                                v-validate="'max:500'"
                                label="Ghi chú"
                                rows="2"
                                v-model="createItem.content"
                                name="request_content"
                                data-vv-as="Ghi chú"
                                :error-messages="errors.first('request_content')"
                            />
                          <template v-else>
                            <p class="font-weight-bold">
                              Ghi chú:
                            </p>
                            <p>{{ createItem.content }}</p>
                          </template>

                        </v-flex>
                      <v-flex md4 style="padding: 10px">
                        <v-btn color="primary" @click="showSelectMaterial" v-if="showUpdate">
                          Chọn vật tư
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <table class="lstTable">
                                <tr>
                                    <th>{{$t('lang.material.materialType')}}</th>
                                    <th>Tên vật tư</th>
                                    <th width="150">Đơn vị</th>
                                    <th width="150">Tồn kho</th>
                                    <th width="150">Số lượng cần xuất</th>
                                    <th width="150" v-if="isDirector">Đơn giá</th>
                                    <th width="150" v-if="isDirector">Thành tiền</th>
                                    <th>Mục đích sử dụng</th>
                                    <th width="100" v-if="showUpdate">{{$t('lang.common.delete')}}</th>
                                </tr>
                                <template v-for="(item, index) in lstMaterial">
                                    <tr v-if="item.materialId == undefined || item.materialId == ''" :key="'mat'+index">
                                        <td style="font-weight: bold">{{item.typeName}}</td>
                                        <td colspan="7">Không có vật tư </td>
                                    </tr>
                                    <tr v-else :key="'mat'+index">
                                        <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0" style="font-weight: bold">{{item.typeName}}</td>
                                        <td>{{ item.materialName }}</td>
                                        <td style="text-align: center">{{ item.unit }}</td>
                                        <td style="text-align: center">{{ item.inventory | currency }}</td>
                                        <td v-if="showUpdate">
                                            <c-input-number
                                                v-model="lstMaterial[index].total_export"
                                                v-on:input="setInput"
                                                @keydown="keyProcess"
                                                :id="'input_' + index + '_' + 0"
                                                :data-row="index"
                                                :data-col="0"
                                                styles="text-align: right; width: 100px;outline: none;"
                                                :disabled="item.inventory == 0 ? true : false"
                                            />
                                        </td>
                                        <td v-else style="text-align: center">{{ item.total_export | currency }}</td>
                                        <td style="text-align: center" v-if="isDirector">{{ item.price != undefined ? item.price : 0 | currency }}</td>
                                        <td style="text-align: center" v-if="isDirector">{{ item.amount != undefined ? item.amount : 0 | currency }}</td>
                                        <td>
                                            <v-textarea
                                                v-if="showUpdate"
                                                rows="2"
                                                v-model="lstMaterial[index].content"
                                                @keydown="keyProcess"
                                                :id="'input_' + index + '_' + 1"
                                                :data-row="index"
                                                :data-col="1"
                                            />
                                            <span v-else>{{ item.content }}</span>
                                        </td>
                                        <td v-if="showUpdate" style="text-align: center">
                                            <v-btn icon @click="deleteItem(item)">
                                                <v-icon color="red">delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </template>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="info" @click="historyDlg=true" v-if="exportRequest != undefined && exportRequest.exportId != undefined && exportRequest.exportId != null">
                        {{ $t("lang.common.history") }}
                    </v-btn>
                    <v-btn v-if="showApprove" color="success" @click="onApprove" :disabled="loading">
                        {{ $t("Phê duyệt") }}
                    </v-btn>
                    <v-btn v-if="showReject" color="error" @click="openDialogRejectApprove" :disabled="loading">
                        {{ $t("Không phê duyệt") }}
                    </v-btn>
                    <v-btn v-if="showConfirm" color="success" @click="onConfirm" :disabled="loading">
<!--                      ky su xac nhan-->
                        {{ $t("Xác nhận") }}
                    </v-btn>

                    <v-btn v-if="showUpdate" color="primary" @click="onSave" :disabled="loading">
                        {{ $t("lang.common.update") }}
                    </v-btn>

                  <v-btn v-if="showConfirmWarehouseKeeper" color="success" @click="onConfirmWarehouseKeeper" :disabled="loading">
                    <!-- thu kho xac nhan-->
                    {{ $t("Xác nhận") }}
                  </v-btn>
                    <v-btn v-if="showCancel" color="error" @click="openDialogCancelExport" :disabled="loading">
                        {{ $t("Hủy phiếu") }}
                    </v-btn>
                  <v-btn v-if="showDelete" color="error" @click="onDeleteExport" :disabled="loading">
                    {{ $t("lang.common.delete") }}
                  </v-btn>
                    <v-btn v-if="showPrint" color="info" @click="onPrint" :disabled="loading">
                        {{ $t("In phiếu") }}
                    </v-btn>
                    <v-btn color="warning" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.back") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
        <material-list
            :cDialog="materialDlg"
            @select="onSelectMaterial"
            :lstSelectedMaterial="lstMaterial"
            @closeDialog="closeMaterialListDialog"
        />
        <dialog-reject-approve 
            :dialog="dialogRejectApprove"
            @close="closeDialogRejectApprove"
            @onRejectApprove="onRejectApprove"
        />
        <dialog-cancel-export
            :dialog="dialogCancelExport"
            @close="closeDialogCancelExport"
            @onCancelExport="onCancelExport"
        />
        <dialog-reject-confirm 
            :dialog="dialogRejectConfirm"
            @close="closeDialogRejectConfirm"
            @onRejectConfirm="onRejectConfirm"
        />
      <dialog_history :dialog="historyDlg" :lst-history="lstHistory" @close="closeHistory"/>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import { areaContants, roleConstants, requestConstants } from "@/constants";
import MaterialList from "./component/MaterialList";
import DialogRejectApprove from "./component/DialogRejectApprove.vue";
import DialogRejectConfirm from "./component/DialogRejectConfirm.vue";
import DialogCancelExport from "@/views/admin/export_request/component/DialogCancelExport";
import Dialog_history from "@/views/admin/export_request/component/DialogHistory";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
    name: "NotProcessView",
    components: {
      CTextboxFloat, Dialog_history, MaterialList, DialogRejectApprove,
        DialogCancelExport, DialogRejectConfirm, IDatepicker },
    props: {
        exportId: {
            type: [String,Number],
            default: "-1"
        },
        showDialogHeader: {
            type: Boolean,
            default: true,
        },
        fromSummary: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            exportIdIn: "-1",
            formName: "Đề nghị xuất kho không theo quy trình",
            loading: false,
            cropName: '',
            areaCode: '',
            crop: '',
            lstMaterialType: [],
            // lstMaterialTypeAlly:[],
            lstMaterial: [],
            lstMaterialPrice: [],
            lstAssetsName: [],
            materialDlg: false,
            dialogRejectApprove: false,
            dialogRejectConfirm: false,
            dialogCancelExport: false,
            exportRequest: {
                status: 0,
            },
            createItem: {
                requestNumber: '',
                userCreateId: '',
                userCreateName: '',
                cropId: '',
                exportType: 2,
                shrimpAge: '',
                warehouseId: '',
                assetsNameId: '',
            },
            assetsName: '',
            historyDlg: false,
            lstHistory: [],
        };
    },

    created() {
        // 4: kỹ sư trưởng
        const role = parseInt(this.$store.state.auth.user.role);
        if (role == 4) {
            this.createItem.status = 2;
        } else {
            this.createItem.status = 1;
        }

        if (this.exportId != undefined && this.exportId != "" && this.exportId != "-1") {
            this.exportIdIn = this.exportId;
        } else if (this.$route.params.id != undefined && this.$route.params.id != "") {
            this.exportIdIn = this.$route.params.id;
        }
        
        // this.createItem.userCreateId = this.$store.state.auth.user.userId;
        // this.createItem.userCreateName = this.$store.state.auth.user.fullName;
        // this.createItem.exportDate = moment().format('YYYY-MM-DD');
        // this.getMaterialTypeAlly();
        // this.getNextCode();
        // this.getCrop();
        // this.getMaterialType();
        this.getAssetsName();
    },
    computed: {
        isDirector() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR) {
                return true;
            } else {
                return false;
            }
        },
        showApprove() {
            // return true;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
                return true;
            } else {
                return false;
            }
        },
        showReject() {
            // return true;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
                return true;
            } else {
                return false;
            }
        },
        showRejectConfirm() {
            // return true;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && this.exportRequest.status == areaContants.exportRequestStatus.created) {
                return true;
            } else {
                return false;
            }
        },
        showCancel  () {
            // return true;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.exportRequest.status == areaContants.exportRequestStatus.approved) {
                return true;
            } else {
                return false;
            }
        },
        showUpdate() {
            // return true;
            if (
                (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ENGINEER
                && this.exportRequest.status == areaContants.exportRequestStatus.created)
                || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && this.exportRequest.status == areaContants.exportRequestStatus.created)
                || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && this.exportRequest.status == areaContants.exportRequestStatus.confirmed)
                || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && this.exportRequest.status == areaContants.exportRequestStatus.approved)
                || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && this.exportRequest.status == areaContants.exportRequestStatus.incomplete)) {
                return true;
            } else {
                return false;
            }
        },
        showConfirm () {
            // return true;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && this.exportRequest.status == areaContants.exportRequestStatus.created) {
                return true;
            } else {
                return false;
            }
        },

        showConfirmWarehouseKeeper() {
          // return true;
          if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
              && this.exportRequest.status == areaContants.exportRequestStatus.approved 
              && this.exportId == -1) {
            return true;
          } else {
            return false;
          }
        },
        showPrint () {
            // return true;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && (this.exportRequest.status == areaContants.exportRequestStatus.approved
                    || this.exportRequest.status == areaContants.exportRequestStatus.completed)) {
                return true;
            } else {
                return false;
            }
        },
      showDelete() {
        if(this.$store.state.auth.user.userId != this.exportRequest.userCreateId){
          return false;
        }
        if (
            (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && this.exportRequest.status == areaContants.exportRequestStatus.rejected)
            || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
            && this.exportRequest.status == areaContants.exportRequestStatus.confirmed)
            || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ENGINEER
            && this.exportRequest.status == areaContants.exportRequestStatus.created)
            || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ENGINEER
            && this.exportRequest.status == areaContants.exportRequestStatus.rejected
            || this.$store.state.auth.user.userId == this.exportRequest.userCreateId
            && this.exportRequest.status == areaContants.exportRequestStatus.confirmed)
        ) {
          return true;
        } else {
          return false;
        }
      },
    },
    watch: {
        exportId: function (value) {
            this.exportIdIn = value;
        },
        exportIdIn: function (value) {
            this.getExportRequest(value);
            this.getMaterialType();
        },
    },
    methods: {
        //linhdx reload lai array thi moi hien thi dc c-textbox-float
        setInput(){
          this.lstMaterial = [...this.lstMaterial]
        },
        // getMaterialTypeAlly() {
        //   axios.post(
        //       process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE_ALLY"
        //   ).then(
        //       (data) => {
        //         if (data.length > 0) {
        //           this.lstMaterialTypeAlly = data;
        //         }
        //       }
        //   );
        // },
        getExportRequest(exportId) {
            if (exportId != -1) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/exportRequest/search?pageSize=-1&page=-1",
                        {exportId: exportId}
                    )
                    .then((data) => {
                    if (data.items) {
                        const exportRequest = data.items[0];
                        this.getMaterialPrice(exportRequest.warehouseId);
                        exportRequest.exportDate = moment(String(exportRequest.exportDate)).format('YYYY-MM-DD');
                        this.getCrop(exportRequest.cropId);
                        this.getPondArea(exportRequest.areaId);
                        
                        this.lstMaterial = JSON.parse(exportRequest.requestData);
                        this.lstMaterialCurrent = JSON.parse(exportRequest.requestData);

                        this.createItem = exportRequest;
                        console.log(this.createItem);
                        this.exportRequest = exportRequest;
                        this.getHistory(this.exportRequest);
                        // this.getHistory(this.exportRequest);
                    }
                    });
            }
        },
        onSave() {
            if(this.lstMaterial.length < 1){
                message.error("Không có vật tư");
                return;
            }

            const lstMaterial = this.lstMaterial;
            let rt = true;
            $.each(lstMaterial, function (k, v) {
                if (parseFloat(v.inventory) > 0) {
                    if (v.total_export === '') {
                        message.error("Có vật tư chưa nhập số lượng xuất kho");
                        rt = false;
                    }
                    if (parseFloat(v.total_export) > parseFloat(v.inventory)) {
                        message.error("Tổng đề xuất không được vượt quá số lượng tồn kho");
                        rt = false;
                    }
                }
                
                lstMaterial[k].amount = parseFloat(lstMaterial[k].total_export) * parseFloat(lstMaterial[k].price);
            });
            if(!rt){
              return;
            }

            const createItem = this.createItem;
            createItem.requestData = JSON.stringify(lstMaterial);
            // console.log(createItem);
            // return;
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/exportRequest/save", createItem)
                .then(
                    (data) => {
                        if (data.success) {
                            message.success(
                                this.$t("lang.common.save_success")
                            );
                            this.onCancel();
                        } else {
                            message.error(this.$t(data.description));
                        }
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        onCancel() {
            //this.$router.push({ path: '/exportRequest' });
            this.$router.push({ path: `/exportRequest`, query: this.$route.query });
        },
        onCancelExport(reason) {
            this.loading = true;
            this.exportRequest.reason = reason
            axios
                .post(process.env.VUE_APP_API_URL + "/exportRequest/reject", this.exportRequest)
                .then(
                    (data) => {
                        if (data.success) {
                        message.success(this.$t("lang.common.save_success"));
                        this.onCancel();
                        } else {
                        message.error(this.$t("lang.common.save_error"));
                        }
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        onApprove() {
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/exportRequest/approve", this.exportRequest)
                .then(
                    (data) => {
                        if (data.success) {
                        message.success(this.$t("lang.common.save_success"));
                        if(!this.fromSummary){
                            this.onCancel();
                        } else{
                            this.$router.go(0);
                            //this.$router.push({path: '/exportRequest/confirm/' + this.exportRequest.areaId + "/requestDate/"+ this.exportRequest.requestDate});
                        }
                        } else {
                        message.error(this.$t("lang.common.save_error"));
                        }
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        onRejectApprove(reason = '') {
            this.loading = true;
            const exportRequest = this.exportRequest;
            exportRequest.reason = reason;
            axios
                .post(process.env.VUE_APP_API_URL + "/exportRequest/reject", exportRequest)
                .then(
                    (data) => {
                        if (data.success) {
                        message.success(this.$t("lang.common.save_success"));
                        if(!this.fromSummary){
                            this.onCancel();
                        } else{
                            this.$router.go(0);
                            //this.$router.push({path: '/exportRequest/approve/' + this.exportRequest.areaId + "/requestDate/"+ this.exportRequest.exportDate});
                        }
                        } else {
                        message.error(this.$t("lang.common.save_error"));
                        }
                        this.closeDialogRejectApprove();
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        onConfirm() {
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/exportRequest/confirm", this.exportRequest)
                .then(
                    (data) => {
                        if (data.success) {
                        message.success(this.$t("lang.common.save_success"));
                        if(!this.fromSummary){
                            this.onCancel();
                        } else{
                            this.$router.go(0);
                            //this.$router.push({path: '/exportRequest/confirm/' + this.exportRequest.areaId + "/requestDate/"+ this.exportRequest.requestDate});
                        }
                        } else {
                        message.error(this.$t("lang.common.save_error"));
                        }
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },

        onConfirmWarehouseKeeper() {
            const lstMaterial = this.lstMaterial;
            let rt = true;
            for (let i = 0; i < lstMaterial.length; i++) {
                lstMaterial[i].quantity = lstMaterial[i].total_export;

                if (parseFloat(lstMaterial[i].total_export) > parseFloat(lstMaterial[i].inventory)) {
                    message.error("Số lượng xuất kho không được vượt quá số lượng tồn kho");
                    rt = false;
                }
            }
            if(!rt){
              return;
            }
            // return;
            const exportData = JSON.stringify(lstMaterial);
            const exportItem = {
                areaId: this.exportRequest.areaId,
                exportData: exportData,
                exportNumber: this.exportRequest.requestNumber,
                exportRequestId: this.exportRequest.exportId,
                warehouseId: this.exportRequest.warehouseId,
                exportSuccess: 1,
                exportType: 2,
                userCreateId: this.$store.state.auth.user.userId,
                userCreateName: this.$store.state.auth.user.fullname,
                importWhId: this.exportRequest.importWhId,
            };
            // console.log(exportItem);
            // return;
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/exportWh/save", exportItem)
                .then(
                    (data) => {
                        if (data.success) {
                            message.success(this.$t("lang.common.save_success"));
                            if(!this.fromSummary){
                                this.onCancel();
                            } else{
                            this.$router.go(0);
                            //this.$router.push({path: '/exportRequest/confirm/' + this.exportRequest.areaId + "/requestDate/"+ this.exportRequest.requestDate});
                            }
                        } else {
                            message.error(this.$t("lang.common.save_error"));
                        }
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        onRejectConfirm(reason = '') {
            this.loading = true;
            const exportRequest = this.exportRequest;
            exportRequest.reason = reason;
            axios
                .post(process.env.VUE_APP_API_URL + "/exportRequest/reject", exportRequest)
                .then(
                    (data) => {
                        if (data.success) {
                        message.success(this.$t("lang.common.save_success"));
                        if(!this.fromSummary){
                            this.onCancel();
                        } else{
                            this.$router.go(0);
                        }
                        } else {
                        message.error(this.$t("lang.common.save_error"));
                        }
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
      onDeleteExport() {
        if (confirm(this.$t("lang.common.deleteConfirm"))) {
          this.loading = true;
          axios
              .post(process.env.VUE_APP_API_URL + "/exportRequest/delete", this.exportRequest)
              .then(
                  (data) => {
                    if (data) {
                      message.success(this.$t("lang.common.delete_success"));
                      this.onCancel();
                    } else {
                      message.error(this.$t("lang.common.deleteError"));
                    }
                    this.loading = false;
                  },
                  (error) => {
                    this.loading = false;
                    console.log(error);
                  }
              );
        }
      },
      onPrint() {
        axios({
          url: process.env.VUE_APP_API_URL + "/exportRequest/exportExcelNotProcess",
          method: "POST",
          data: this.exportRequest,
          responseType: "blob", // important
        }).then(response => {
          if (response) {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "De_nghi_xuat_kho_kqt" + ".xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          }
        });
      },
        openDialogRejectApprove() {
            this.dialogRejectApprove = true;
        },
        closeDialogRejectApprove() {
            this.dialogRejectApprove = false;
        },
        openDialogRejectConfirm() {
            this.dialogRejectConfirm = true;
        },
        closeDialogRejectConfirm() {
            this.dialogRejectConfirm = false;
        },
        openDialogCancelExport () {
            this.dialogCancelExport = true;
        },
        closeDialogCancelExport() {
            this.dialogCancelExport = false;
        },
        getCrop(cropId) {
          if(cropId == undefined){
            this.cropName = null;
            return;
          }
            axios.post(
                    process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1",
                    {cropId: cropId}
                )
                .then((data) => {
                    if (data.items && data.items[0] != undefined) {
                        this.cropName = data.items[0].name;
                    }
                });
        },
        getPondArea(areaId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=PONDAREA&pageSize=-1&page=-1",
                {categoryId: areaId}
            )
            .then((data) => {
                if (data.items) {
                    this.areaCode = data.items[0].categoryName;
                    this.getWarehouse(data.items[0].categoryId);
                }
            });
        },
        getWarehouse(parentId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=WAREHOUSE&pageSize=-1&page=-1",
                {parentId: parentId}
            )
            .then((data) => {
                if (data.items) {
                    this.createItem.warehouseId = data.items[0].categoryId;
                    this.getWarehouseInventory(data.items[0].categoryId);
                }
            });
        },
        getWarehouseInventory(warehouseId) {
            axios.post(
                    process.env.VUE_APP_API_URL + "/warehouse/search?pageSize=-1&page=-1",
                    {warehouseId: warehouseId}
                )
                .then((data) => {
                    if (data.items) {
                        this.lstInventory = data.items;
                        this.reCalculate();
                    }
                });
        },
        getMaterialType() {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE"
            ).then(
                (data) => {
                    if (data.length > 0) {
                        this.lstMaterialType = data;
                    }
                }
            );
        },
        getNextCode() {
            axios
                .get(
                    process.env.VUE_APP_API_URL +
                        "/autoIncrease/getNextCode?type=ĐNX&prefix=ĐNX/&numberZeroBeforeCodeNumberCode=2&suffix="
                )
                .then((data) => {
                    this.createItem.requestNumber = data;
                });
        },
        keyProcess($event) {
            let group = 'input';
            let row = parseInt($event.target.getAttribute("data-row"));
            let col = parseInt($event.target.getAttribute("data-col"));
            switch ($event.keyCode) {
                case 13:
                    col += 1;
                    let id = group + '_' + row + '_' + col;
                    var element = document.getElementById(id);
                    // console.log();
                    if (typeof (element) != 'undefined' && element != null) {
                        element.focus();
                    } else {
                        row += 1;
                        col = 0;
                        id = group + '_' + row + '_' + col;
                        let element2 = document.getElementById(id);
                        if (typeof (element2) != 'undefined' && element2 != null) {
                            element2.focus();
                        } else {
                            document.getElementById($event.target.getAttribute("id")).blur();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 37:
                    // left
                    if (col >= 0) {
                        col -= 1;
                        let id = group + '_' + row + '_' + col;
                        let element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 38:
                    // up
                    if (row >= 0) {
                        row -= 1;
                        let id = group + '_' + row + '_' + col;
                        let element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 39:
                    //right
                    if (col >= 0) {
                        col += 1;
                        let id = group + '_' + row + '_' + col;
                        // document.getElementById(id).focus();
                        var element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 40:
                    //down
                    if (row >= 0) {
                        row += 1;
                        let id = group + '_' + row + '_' + col;
                        var element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
            }
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        getShrimpAge(calcuDate = '') {
            const item = this.crop;
            if (item == '') {
                return 0;
            }
            let calculateDate = calcuDate != '' ? calcuDate : moment().format('YYYY-MM-DD');
            
            let shrimpAge = '';
            let dropDate = '';
            if (parseInt(item.pondParent) > 0 && item.dropDateParent != '' && item.dropDateParent != null) {
                dropDate = moment(String(item.dropDateParent));
            } else if (item.dropDate != '' && item.dropDate != null) {
                dropDate = moment(String(item.dropDate));
            }
            if (dropDate != '') {
                let calculateDateMM = moment(String(calculateDate));
                let endDate = moment(String(calculateDate));
                if (item.endDate) {
                    endDate = moment(String(item.endDate));
                    if (endDate > calculateDateMM) endDate = calculateDateMM;
                }
                if (endDate > dropDate) {
                    let dates = endDate.diff(dropDate, "days");
                    if (dates >= 0) {
                        shrimpAge = dates;
                    }
                }
            }
            this.createItem.shrimpAge = shrimpAge;
        },
        reCalculate() {
            for (let i = 0; i < this.lstMaterial.length; i++) {
                if (this.lstMaterial[i].total_export == undefined) {
                    this.lstMaterial[i].total_export = '';
                }
                if (this.lstMaterial[i].inventory == undefined) {
                    this.lstMaterial[i].inventory = 0;
                }
                if (this.lstMaterial[i].price == undefined) {
                    this.lstMaterial[i].price = 0;
                }
                if (this.lstMaterial[i].amount == undefined) {
                    this.lstMaterial[i].amount = 0;
                }
            }

            //
            // sort by typeId
            //
            this.lstMaterial.sort((o1, o2) => {
                if (o1.typeId == o2.typeId) {
                    return o1.materialName.localeCompare(o2.materialName);
                } else {
                    return o1.typeId - o2.typeId;
                }
            })
            //linhdx reset het row material = ""
            for (let j = 0; j < this.lstMaterial.length; j++) {
              this.lstMaterial[j].row = null;
            }
            for (let i = 0; i < this.lstMaterialType.length; i++) {
                this.lstMaterialType[i].count = 0;
                for (let j = 0; j < this.lstMaterial.length; j++) {
                    if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                        this.lstMaterialType[i].count++;
                    }
                }
                if (this.lstMaterialType[i].count != 0) {
                    for (let j = 0; j < this.lstMaterial.length; j++) {
                        if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                            this.lstMaterial[j].typeName = this.lstMaterialType[i].categoryName;
                            this.lstMaterial[j].row = this.lstMaterialType[i].count;
                            break;
                        }
                    }
                }
            }
            
            // inventory
            const lstInventory = this.lstInventory;
            const lstMaterial = this.lstMaterial;
            if (lstInventory != undefined && lstMaterial != undefined) {
                for (let i = lstMaterial.length - 1; i >= 0; i--) {
                    // if (lstMaterial[i].inventory == undefined || lstMaterial[i].inventory == 0) {
                        const inv = lstInventory.filter(function(o) {
                            return lstMaterial[i].materialId == o.materialId;
                        });
                        if (inv != undefined && inv[0] != undefined) {
                            lstMaterial[i].inventory = inv[0].quantity;
                        }
                    // }

                    // material price
                    if (lstMaterial[i].price == undefined || lstMaterial[i].price == 0) {
                        const matPrice = this.lstMaterialPrice.find((v) => v.materialId === lstMaterial[i].materialId);
                        if (matPrice != undefined) {
                            lstMaterial[i].price = matPrice.averagePrice;
                        }
                    }
                }
            }

            this.lstMaterial = lstMaterial;
        },
        onChangeExportDate() {
            this.getShrimpAge(this.createItem.exportDate);
            this.reCalculate();
        },
        onSelectMaterial(lstSelectMaterial) {
          for (let j = this.lstMaterial.length-1;j>=0; j--) {
            let bHas = false;
            for (let i = 0; i < lstSelectMaterial.length; i++) {
              if (this.lstMaterial[j].materialId == lstSelectMaterial[i].materialId) {
                bHas = true;
                break;
              }
            }
            if(!bHas){
              this.lstMaterial.splice(j);
            }
          }
          for (let i = 0; i < lstSelectMaterial.length; i++) {
            let bHas = false;
            for (let j = 0; j < this.lstMaterial.length; j++) {
              if (this.lstMaterial[j].materialId == lstSelectMaterial[i].materialId) {
                bHas = true;
                break;
              }
            }
            if (!bHas) {
              lstSelectMaterial[i].row = "";
              this.lstMaterial.push(lstSelectMaterial[i]);
            }
          }
          this.reCalculate();
        },
        closeMaterialListDialog() {
            this.materialDlg = false;
        },
        showSelectMaterial() {
            this.materialDlg = true;
        },
        deleteItem(item){
            if(confirm("Bạn có chắc xóa vật tư "+ item.materialName + " khỏi đề nghị xuất hàng không?")){
                for(let i = 0; i < this.lstMaterial.length; i++){
                    if(this.lstMaterial[i].materialId == item.materialId){
                        this.lstMaterial.splice(i,1);
                        break;
                    }
                }
                this.reCalculate();
            }
        },
        closeHistory(){
          this.historyDlg =false;
        },
        getHistory(exportRequest) {
          axios.post(
              process.env.VUE_APP_API_URL + "/exportRequest/searchHistory?exportId=" + exportRequest.exportId).then(
              (data) => {
                this.lstHistory = data;
              }
          );
        },
        exportStatusName() {
            const self = this;
            let name = '';
            const status = requestConstants.requestExportStatus.find(function (e) {
                return e.value == self.exportRequest.status;
            });
            if (status != undefined) {
                name = status.text;
            }
            return name;
        },
        getMaterialPrice(warehouseId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/materialPrice/search?pageSize=-1&page=-1", {warehouseId: warehouseId}
            )
                .then((data) => {
                    if (data.items) {
                        this.lstMaterialPrice = data.items;
                    }
                });
        },
        onInputChange($event) {
            const row = parseInt($event.target.getAttribute("data-row"));
            this.lstMaterial[row].amount = parseFloat($event.target.value) * this.lstMaterial[row].price;
        },
        getAssetsName() {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=ASSETS_NAME&pageSize=-1&page=-1",
                {}
            )
            .then((data) => {
                if (data.items) {
                    this.lstAssetsName = data.items;
                }
            });
        },
        getAssetsNameName(assetsNameId) {
            const assetsName = this.lstAssetsName.find((v) => v.categoryId === assetsNameId);
            let name = '';
            if (assetsName != undefined) {
                name = assetsName.categoryName;
            }
            return name;
        },
    },

    destroyed() {},
};
</script>
